(() => {
  const selectors = {
    root: '[data-vmax-member-register]',
    dialog: '.vmax-member-register__dialog',
    overlay: '.vmax-member-register__overlay',
    open: '[data-vmax-member-register-open]',
    close: '[data-vmax-member-register-close]',
    form: '[data-vmax-member-register-form]',
    otp: '[data-vmax-member-register-otp]',
    message: '[data-vmax-member-register-message]'
  };

  const setMessage = (root, text, tone = '') => {
    const message = root.querySelector(selectors.message);
    if (!message) return;
    message.textContent = text;
    if (tone) message.dataset.tone = tone;
    else delete message.dataset.tone;
  };

  const getFormPayload = (form) => {
    const data = new FormData(form);
    const payload = {
      countryCode: String(data.get('countryCode') || ''),
      phone: String(data.get('phone') || ''),
      password: String(data.get('password') || ''),
      otpCode: String(data.get('otpCode') || ''),
      displayName: String(data.get('displayName') || '') || undefined,
      email: String(data.get('email') || '') || undefined,
      birthday: String(data.get('birthday') || '') || undefined,
      gender: String(data.get('gender') || '') || undefined,
      locale: document.documentElement.lang || undefined,
      registeredFrom: 'shopify-membership',
      marketingConsent: data.get('marketingConsent') === 'true',
      emailConsent: data.get('emailConsent') === 'true',
      smsConsent: data.get('smsConsent') === 'true',
      whatsappConsent: data.get('whatsappConsent') === 'true'
    };

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === '') delete payload[key];
    });

    return payload;
  };

  const requestJson = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json.message || json.code || 'Request failed.');
    }
    return json;
  };

  const openModal = (root) => {
    const dialog = root.querySelector(selectors.dialog);
    const overlay = root.querySelector(selectors.overlay);
    if (!dialog || !overlay) return;
    overlay.hidden = false;
    dialog.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const firstInput = dialog.querySelector('select, input, button');
    if (firstInput) firstInput.focus();
  };

  const closeModal = (root) => {
    const dialog = root.querySelector(selectors.dialog);
    const overlay = root.querySelector(selectors.overlay);
    if (!dialog || !overlay) return;
    dialog.hidden = true;
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  };

  if (window.vmaxMemberRegisterAttached) return;
  window.vmaxMemberRegisterAttached = true;

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest(selectors.open);
    if (openButton) {
      event.preventDefault();
      const root = document.querySelector(selectors.root);
      if (root) openModal(root);
      return;
    }

    const closeButton = event.target.closest(selectors.close);
    if (closeButton) {
      const root = closeButton.closest(selectors.root);
      if (root) closeModal(root);
      return;
    }

    const otpButton = event.target.closest(selectors.otp);
    if (!otpButton) return;

    const root = otpButton.closest(selectors.root);
    const form = root && root.querySelector(selectors.form);
    if (!root || !form) return;

    const payload = getFormPayload(form);
    if (!payload.countryCode || !payload.phone) {
      setMessage(root, 'Country and phone are required.', 'error');
      return;
    }

    otpButton.disabled = true;
    setMessage(root, 'Sending code...');

    try {
      const json = await requestJson(`${root.dataset.apiBaseUrl}/auth/request-otp`, {
        countryCode: payload.countryCode,
        phone: payload.phone,
        purpose: 'REGISTER'
      });
      setMessage(root, json.mockCode ? `Code sent. Dev code: ${json.mockCode}` : 'Code sent.', 'success');
    } catch (error) {
      setMessage(root, error instanceof Error ? error.message : 'Could not send code.', 'error');
    } finally {
      otpButton.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(selectors.form);
    if (!form) return;
    event.preventDefault();

    const root = form.closest(selectors.root);
    if (!root) return;

    const submit = form.querySelector('[type="submit"]');
    const payload = getFormPayload(form);

    submit.disabled = true;
    setMessage(root, 'Creating membership...');

    try {
      const json = await requestJson(`${root.dataset.apiBaseUrl}/auth/register`, payload);
      window.localStorage.setItem('vibemaxMemberToken', json.token);
      setMessage(root, 'Membership created.', 'success');
      window.dispatchEvent(new CustomEvent('vibemax:member-registered', { detail: json }));
    } catch (error) {
      setMessage(root, error instanceof Error ? error.message : 'Could not create membership.', 'error');
    } finally {
      submit.disabled = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(selectors.root).forEach(closeModal);
  });
})();
